import { getItems } from "services/selectListItemService";

export const getSelectList = (endpoint) => async (dispatch) => {
    dispatch({ type: 'FETCH_SELECT_LIST_REQUEST' });
    try {
        const result = await getItems("/users/options");
        const options = result.map(item => ({
            key: item.key,
            text: item.value
        }));
        dispatch({ type: 'FETCH_SELECT_LIST_SUCCESS', payload: options });
    } catch (error) {
        dispatch({ type: 'FETCH_SELECT_LIST_FAILURE', error: error.message });
    }
};
